import React from 'react';
import cometChatLogo from "CometChat/assets/cometchat_logo.svg";

function ErrorPage(): JSX.Element {
  return (
    <div 
      className="error-page"
      style={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        textAlign: 'center',
        padding: '20px',
        gap: '20px'
      }}
    >
      <div className="cometchat-credentials__logo">
        <img src={cometChatLogo} alt="CometChat Logo" />
      </div>
      <h1 style={{ color: '#e74c3c', fontSize: '2rem' }}>
        Error de autenticación
      </h1>
      <p style={{ fontSize: '1.2rem', color: '#555' }}>
        No se pudo verificar tu identidad. El token JWT no es válido o no se proporcionó.
      </p>
      <p style={{ fontSize: '1rem', color: '#888' }}>
        Por favor, intenta acceder de nuevo con un enlace válido.
      </p>
      <button 
        onClick={() => window.location.href = '/'}
        style={{
          padding: '10px 20px',
          fontSize: '1rem',
          backgroundColor: '#3498db',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Reintentar
      </button>
    </div>
  );
}

export default ErrorPage;